import { Badge, Button, Card, CardBody, Col, Row } from "reactstrap";
import { TiLocation } from "react-icons/ti";
import { RiDirectionLine } from "react-icons/ri";
import { FaStar } from "react-icons/fa";
import { SaveIcon } from "../../assets/designedPickedIcons";

const MostRecentPlaceCard = ({ details }) => {
  return (
    <Card className="most-recent-card">
      <Row className="g-2">
        <Col md={4} xxl={3}>
          <img
          src={details?.photos?.[0]}
            height={260}
            style={{ borderRadius: "10.87px" }}
            className="full-width object-fit-cover"
          />
        </Col>
        <Col md={8} className="p-0" xxl={9}>
          <CardBody className="padding-top-23px padding-bottom-23px padding-left-23px padding-right-32px">
            <div className="d-flex align-items-center mb-3  justify-content-between">
              <div>
                <h4 className="f-6 mb-2">{details?.name}</h4>
                <h4 className="m-0 f-4 color-half-black-3 baloo-font">
                  {details?.types?.[0]}
                </h4>
              </div>
              <div className="bg-white badge border-none figma-shadow-1 color-primary-yellow-1">
                <SaveIcon /> Saved
              </div>
            </div>
            <div className="d-flex align-items-center mb-3 gap-2 ">
              <TiLocation size={24} color="rgba(6, 84, 60, 1)" />
              <h5 className="color-primary-black-9 f-4 m-0">
                {details?.location?.streetAddress}
              </h5>
            </div>
            <h5 className="color-primary-black-10 mb-4">{details?.reviews?.length}</h5>
            <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between ">
              <div className="d-flex color-primary-green-4 align-items-center gap-0_4rem">
                <RiDirectionLine size={27} />
                <h4 className="m-0 color-primary-green-4 urbanist-font f-6">Directions</h4>
                <h5 className="m-0 color-primary-black-9 f-4 ">25 minutes</h5>
              </div>
              <div className="d-flex align-items-center gap-5_1px">
                <h3 className="color-primary-black-10 m-0">
                  {details?.totalReviews ?? 0}
                </h3>
                <FaStar size={22} color="rgba(246, 201, 68, 1)" />
              </div>
            </div>
          </CardBody>
        </Col>
      </Row>
    </Card>
  );
};

export default MostRecentPlaceCard;
